module.exports = __webpack_public_path__ + "7709f09f2086cc6f774c6a90fc56936a.svg";